<div class="yf-container" style="gap: 24px">
  <ion-text color="medium">
    <p>{{ 'NOTIF_PREFS.PROMPT_TEXT' | translate }}</p>
  </ion-text>
  <ion-list style="width: 100%" *ngIf="!isLoading">

    <!-- Le tue ricariche (PERSONAL: inizio/stato/fine sessione, prenotazioni) -->
    <ion-list-header>
      <ion-label>{{ 'NOTIF_PREFS.PERSONAL_SECTION' | translate }}</ion-label>
    </ion-list-header>
    <ion-item lines="none">
      <ion-note style="font-size: 13px">{{ 'NOTIF_PREFS.PERSONAL_HINT' | translate }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-toggle [(ngModel)]="personalPushEnabled" [disabled]="isSaving" (ionChange)="onToggleChange()">
        {{ 'NOTIF_PREFS.PERSONAL_PUSH' | translate }}
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle [(ngModel)]="personalEmailEnabled" [disabled]="isSaving" (ionChange)="onToggleChange()">
        {{ 'NOTIF_PREFS.PERSONAL_EMAIL' | translate }}
      </ion-toggle>
    </ion-item>

    <!-- Comunicazioni di servizio (SERVICE: avvisi operativi rete, NON pagamenti) -->
    <ion-list-header>
      <ion-label>{{ 'NOTIF_PREFS.SERVICE_SECTION' | translate }}</ion-label>
    </ion-list-header>
    <ion-item lines="none">
      <ion-note style="font-size: 13px">{{ 'NOTIF_PREFS.SERVICE_HINT' | translate }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-toggle [(ngModel)]="servicePushEnabled" [disabled]="isSaving" (ionChange)="onToggleChange()">
        {{ 'NOTIF_PREFS.SERVICE_PUSH' | translate }}
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle [(ngModel)]="serviceEmailEnabled" [disabled]="isSaving" (ionChange)="onToggleChange()">
        {{ 'NOTIF_PREFS.SERVICE_EMAIL' | translate }}
      </ion-toggle>
    </ion-item>

    <!-- Novità e promozioni (MARKETING: opt-in GDPR) -->
    <ion-list-header>
      <ion-label>{{ 'NOTIF_PREFS.MARKETING_SECTION' | translate }}</ion-label>
    </ion-list-header>
    <ion-item lines="none">
      <ion-note style="font-size: 13px">{{ 'NOTIF_PREFS.MARKETING_HINT' | translate }}</ion-note>
    </ion-item>
    <ion-item>
      <ion-toggle [(ngModel)]="marketingPushEnabled" [disabled]="isSaving" (ionChange)="onToggleChange()">
        {{ 'NOTIF_PREFS.MARKETING_PUSH' | translate }}
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle [(ngModel)]="marketingEmailEnabled" [disabled]="isSaving" (ionChange)="onToggleChange()">
        {{ 'NOTIF_PREFS.MARKETING_EMAIL' | translate }}
      </ion-toggle>
    </ion-item>
  </ion-list>

  <!-- Nota legale: le notifiche economiche (pagamenti/addebiti) non hanno toggle -->
  <ion-text color="medium">
    <p style="font-size: 13px">
      <ion-icon name="information-circle-outline" style="vertical-align: middle"></ion-icon>
      {{ 'NOTIF_PREFS.LEGAL_PAYMENTS_NOTE' | translate }}
    </p>
  </ion-text>
</div>
